import axios from "axios";

const API_URL = process.env.REACT_APP_DECRYPT_API_URL || "https://services-helexpo.gr/hapi/v1/exhibitions/decrypt";

/**
 * @param {string} encryptedPath - The encrypted path string
 * @returns {Promise<{ExCode: string, PavCode: string, standCode: string}>}
 */
const decryptPath = async (encryptedPath) => {
  try {
    const response = await axios.get(`${API_URL}/${encryptedPath}`);
    
    console.log("Response:", response.data);
    
    if (response.data.err !== 0) {
      throw new Error(response.data.message || "Decryption failed");
    }
    
    const { pavStr } = response.data;
    
    if (!pavStr) {
      throw new Error("Missing pavStr in response");
    }
    
    const parts = pavStr.split('/');
    
    if (parts.length !== 3) {
      throw new Error(`Invalid pavStr format: ${pavStr}`);
    }
    
    const [ExCode, PavCode, standCode] = parts;
    
    console.log("Parsed values:", { ExCode, PavCode, standCode });
    
    return { ExCode, PavCode, standCode };
  } catch (error) {
    console.error("Decryption error:", error);
    console.error("Error response:", error.response?.data);
    throw error;
  }
};

export default decryptPath;